import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import { USERS } from "@/constants/testIds";

export function UserFilters({
  q, onQChange,
  department, onDepartmentChange, departments,
  statusFilter, onStatusChange,
}) {
  return (
    <div className="p-4 border-b border-slate-200 flex items-center gap-3 flex-wrap">
      <div className="relative flex-1 min-w-[240px]">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" strokeWidth={1.75} />
        <Input
          placeholder="Buscar por nombre, correo o cargo..."
          value={q}
          onChange={(e) => onQChange(e.target.value)}
          data-testid={USERS.searchInput}
          className="pl-9 focus-visible:ring-orange-500"
        />
      </div>
      <Select value={department} onValueChange={onDepartmentChange}>
        <SelectTrigger className="w-56 focus:ring-orange-500" data-testid="users-department-filter">
          <SelectValue placeholder="Todos los departamentos" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">Todos los departamentos</SelectItem>
          {departments.map((d) => (
            <SelectItem key={d} value={d}>{d}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={statusFilter} onValueChange={onStatusChange}>
        <SelectTrigger className="w-44 focus:ring-orange-500" data-testid="users-status-filter">
          <SelectValue placeholder="Todos los estados" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__all__">Todos los estados</SelectItem>
          <SelectItem value="active">Solo activos</SelectItem>
          <SelectItem value="disabled">Solo inactivos</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
